import requestConfig from '../../../shared/config/request';
import { get, post, put } from '../../../infra/rest';
import { ACTION_TYPES, CxIssuesListAPIResponseType, cxOverview, CxOverviewMetricsType } from '../typings';

export const getCxOverview = async ({
  searchTerm,
  state,
  issueId,
  userId,
  startDate,
  endDate,
  lastDateCreated,
  pageSize,
  nextLastId,
  selectedMetricCard,
}: {
  searchTerm: string | null;
  lastDateCreated: string | null;
  pageSize: number | null;
  state: string[] | null;
  issueId: string[] | null;
  userId: string[] | null;
  startDate: string | null;
  endDate: string | null;
  nextLastId: string | null;
  selectedMetricCard: ACTION_TYPES | null;
}): Promise<{
  data: cxOverview[];
  metrics: CxOverviewMetricsType;
  hasMore: boolean;
  nextLastDateCreated: string;
  nextLastId: string;
}> => {
  const bodyObject: Record<string, number | string | string[]> = {};
  if (searchTerm) bodyObject['searchTerm'] = searchTerm;
  if (lastDateCreated) bodyObject['lastDateCreated'] = lastDateCreated;
  if (pageSize) bodyObject['pageSize'] = pageSize;
  if (state && state.length > 0 && !state.includes('all')) bodyObject['states'] = state;
  // if (state && state.length == 0) bodyObject['states'] = [];
  if (issueId && issueId.length > 0 && !issueId.includes('all')) bodyObject['issueIds'] = issueId;
  // if (issueId && issueId.length == 0) bodyObject['issueIds'] = [];
  if (userId && userId.length > 0 && !userId.includes('all')) bodyObject['userIds'] = userId;
  // if (userId && userId.length == 0) bodyObject['userIds'] = [];
  if (startDate) bodyObject['startDate'] = startDate.toString();
  if (endDate) bodyObject['endDate'] = endDate.toString();
  if (nextLastId) bodyObject['lastId'] = nextLastId;
  if (selectedMetricCard && selectedMetricCard !== ACTION_TYPES.ALL) bodyObject['selectedState'] = selectedMetricCard;

  const url = `${requestConfig.aiBotBaseUrl}/v1/ai/analytics/customer-cx-issues`;
  return await post<{
    data: cxOverview[];
    hasMore: boolean;
    metrics: CxOverviewMetricsType;
    nextLastDateCreated: string;
    nextLastId: string;
  }>(url, { body: JSON.stringify(bodyObject) }, true, false, true);
};

export const updateCxIssueState = async ({ id, state }: { id: string; state: ACTION_TYPES }): Promise<void> => {
  return await put<void>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/analytics/customer-cx-issues/${id}`,
    {
      body: JSON.stringify({ state }),
    },
    true,
    false,
    true
  );
};

export const getIsCxIssueEnabled = async () => {
  return await get<{ enabled: boolean }>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/analytics/customer-cx-issue-enabled`,
    {},
    true,
    false,
    true
  );
};

export const getCxIssuesList = async () => {
  return await get<CxIssuesListAPIResponseType>(
    `${requestConfig.aiBotBaseUrl}/v1/ai/analytics/cx-issue/list`,
    {},
    true,
    false,
    true
  );
};
